<script setup>
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import PageTitle from "@/components/common/PageTitle.vue";
import NavCard from "@/components/common/NavCard.vue";
import { getAvailableActionsForRoute } from "@/services/api/permissionManagement.js";

const { t } = useI18n();
const actionsCollaborator = ref(null);
const isLoaded = ref(false);

const breadcrumbs = computed(() => [
    {
        label: t("components.settings.permissionManagement.menuList.HR Management"),
        to: "/rhdigital/hr-management"
    }
]);

const cards = computed(() => {
    const baseCards = [];

    if (actionsCollaborator.value?.list?.length) {
        baseCards.push({
            title: "components.rhdigital.hrManagement.collaborator.management",
            subtitle: "components.rhdigital.hrManagement.collaborator.managementDescription",
            icon: "badge",
            routeName: "/rhdigital/hr-management/collaborators",
        });
    }

    return baseCards;
});

onMounted(async () => {
    try {
        actionsCollaborator.value = await getAvailableActionsForRoute(
            "Resources/HR Management/Collaborator"
        );
    } catch (err) {
        console.error("Error Permissions: ", err);
    } finally {
        isLoaded.value = true;
    }
});
</script>

<template>
    <PageTitle v-if="isLoaded" :breadcrumbs="breadcrumbs" />
    <v-card class="bg-white trezo-card base-page-height">
        <NavCard :cards="cards" />
    </v-card>
    <router-view />
</template>
